import StartGame from "components/start-game/start-game";
export default StartGame;
